import { type PropsWithChildren, useMemo, useState } from "react";

import { initialSortValue } from "@/features/hotels/utils/initialHotelsValues";

import {
  HotelSortContext,
  type HotelSortContextValue,
} from "./HotelSortContext";

export const HotelSortProvider = ({ children }: PropsWithChildren) => {
  const [sortValue, setSortValue] =
    useState<HotelSortContextValue["sortValue"]>(initialSortValue);

  const contextValue = useMemo<HotelSortContextValue>(
    () => ({
      sortValue,
      updateSortValue: setSortValue,
      resetSortValue: () => setSortValue(initialSortValue),
    }),
    [sortValue],
  );

  return (
    <HotelSortContext.Provider value={contextValue}>
      {children}
    </HotelSortContext.Provider>
  );
};
